import { render, staticRenderFns } from "./PDP.vue?vue&type=template&id=029828cd&scoped=true"
import script from "./PDP.vue?vue&type=script&lang=js"
export * from "./PDP.vue?vue&type=script&lang=js"
import style0 from "./PDP.vue?vue&type=style&index=0&id=029828cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029828cd",
  null
  
)

export default component.exports